(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[164],{

/***/ 11058:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-US/[business]/access/guides",
      function () {
        return __webpack_require__(42023);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75102);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54666);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62991);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21776);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77868);
/* harmony import */ var _utils_Builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20358);
/* harmony import */ var _components_not_found__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11170);









(0,_builder__WEBPACK_IMPORTED_MODULE_5__/* .registerComponents */ .QR)();
const B2BPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 837).then(__webpack_require__.bind(__webpack_require__, 71837)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(71837)
            ]
    }
});
const PageRoot = (props)=>{
    const { page , model  } = props;
    const [previewPage, setPreviewPage] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(page);
    const [previewModel, setPreviewModel] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(model);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const _getBuilderPreviewPage = async ()=>{
        const previewData = await (0,_utils_Builder__WEBPACK_IMPORTED_MODULE_7__/* .getBuilderPreviewPage */ .xX)(router);
        if (previewData) {
            setPreviewPage(previewData.page);
            setPreviewModel(previewData.model);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (!(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing || _builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isPreviewing */ .Ib.isPreviewing)) return;
        // if (page) return;
        if (router.isFallback) return;
        _getBuilderPreviewPage();
    }, [
        page,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setPreviewPage(page);
    }, [
        page
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setPreviewModel(model);
    }, [
        model
    ]);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            children: "Loading..."
        });
    }
    if (previewPage === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_not_found__WEBPACK_IMPORTED_MODULE_8__/* .NotFound */ .T, {
            locale: _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_6__/* .Locale.USA */ .go.USA
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(B2BPage, {
        page: previewPage,
        model: previewModel
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PageRoot);


/***/ }),

/***/ 42023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _slug___WEBPACK_IMPORTED_MODULE_1__["default"]; }
/* harmony export */ });
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21776);
/* harmony import */ var _slug___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79826);

(0,_builder__WEBPACK_IMPORTED_MODULE_0__/* .registerComponents */ .QR)();
var __N_SSG = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [565,886,564,506,170,774,888,179], function() { return __webpack_exec__(11058); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);